<template>
  <header
      class="header">
    <div class="top"></div>

    <div class="opera">
      <el-icon
          v-if="showBack"
          size="20" style="cursor:pointer;" @click="emit('back')">
        <Back/>
      </el-icon>

      <h5 @click="emit('home')">税务数字账户</h5>

      <div v-for="(item,idx) in currentTitle" :key="idx" class="item">
        {{ item }}
        <span
            v-if="idx != currentTitle.length - 1"
            style="margin-right: 10px;color: #999999;">></span>
      </div>

    </div>
  </header>
</template>

<script setup>
const props = defineProps({
  currentTitle: {
    type: Array,
    default: () => []
  },
  showBack: {
    type: Boolean,
    default: true
  }
});

const emit = defineEmits(['back', 'home']);
</script>


<style scoped lang="scss">
.header {
  .top {
    height: 56px;
    background-image: url(https://static.rhkj.com/renhe_fe/other/316.png);
    background-size: cover;
  }

  .opera {
    color: #333333;
    font-size: 14px;
    display: flex;
    align-items: center;
    height: 40px;
    padding-left: 20px;

    > h5 {
      font-size: 18px;
      color: #666;
      font-weight: 700;
      margin-right: 20px;
      margin-left: 5px;
      cursor: pointer;
    }

    .item {
      color: #666666;
    }
  }
}
</style>
